import script from "./ProductImagesView.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductImagesView.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__